import { render, staticRenderFns } from "./NetworkDetail.vue?vue&type=template&id=c04d2aa2&scoped=true"
import script from "./NetworkDetail.vue?vue&type=script&lang=ts"
export * from "./NetworkDetail.vue?vue&type=script&lang=ts"
import style0 from "./NetworkDetail.vue?vue&type=style&index=0&id=c04d2aa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04d2aa2",
  null
  
)

export default component.exports